import React, { useContext, useEffect, useRef } from 'react';
import { Article, Wrapper } from './Accordion.styles';
import { AccordionItem } from './components/AccordionItem/AccordionItem';
import { JobRiskFactorsProps, StepProps } from '../../FormRisk.types';
import { JobProfileContext } from 'Views/JobProfile/JobProfile.context';
import Analytics from 'helpers/analytics';
import { JobProfileType } from 'Views/JobProfile/JobProfile.enums';

type AccordionProps = {
	steps: StepProps[];
	jobRiskFactors: JobRiskFactorsProps[];
};

export const Accordion = ({ steps, jobRiskFactors }: AccordionProps) => {
	const {
		active,
		jobProfileType,
		riskIndex,
		setJobRiskFactors,
		setRiskIndex,
		setFocusedId,
	} = useContext(JobProfileContext);

	const preventRerender = useRef(false);

	const handleSelectHeader = (id: number, jobProfileRiskFactor: any) => {
		setRiskIndex(id);
		setFocusedId(jobProfileRiskFactor.id);
	};

	const onCheckItem = (state: boolean, id: string, riskNumber: number) => {
		jobRiskFactors.forEach((item) => {
			if (item.jobProfileRiskFactor.id === id) {
				Analytics.track(
					'job-profile',
					`${
						jobProfileType === JobProfileType.RISK_PROFILE
							? '(Risk Profile)'
							: '(Exposure Area)'
					} (${steps[active].name} Risk) factors ${
						state ? 'selected' : 'unselected'
					}`,
				);
				item.isChecked = state;
				state && handleSelectHeader(riskNumber, item.jobProfileRiskFactor);
			}
		});
		setJobRiskFactors([...jobRiskFactors]);
	};

	useEffect(() => {
		if (jobRiskFactors.length && !preventRerender.current) {
			const firstSelectedFactor = jobRiskFactors.findIndex(
				(factor) => factor.isChecked,
			);

			if (firstSelectedFactor !== -1) {
				handleSelectHeader(
					firstSelectedFactor,
					jobRiskFactors[firstSelectedFactor]?.jobProfileRiskFactor,
				);
			}
			preventRerender.current = true;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [jobRiskFactors]);

	return (
		<Wrapper>
			<Article>
				{jobRiskFactors?.map((risk, index) => {
					return (
						<AccordionItem
							key={index}
							active={riskIndex}
							item={{ ...risk, id: index }}
							onCheckItem={onCheckItem}
							onSelectHeader={(id) => {
								handleSelectHeader(id, risk.jobProfileRiskFactor);
							}}
						/>
					);
				})}
			</Article>
		</Wrapper>
	);
};
